var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', [_c('v-data-table', _vm._b({
    staticClass: "v-sheet--outlined",
    attrs: {
      "disable-filtering": "",
      "disable-pagination": "",
      "disable-sort": "",
      "hide-default-footer": "",
      "item-class": "class"
    },
    on: {
      "click:row": function (item) {
        return _vm.open(item);
      }
    },
    scopedSlots: _vm._u([{
      key: `item.class`,
      fn: function (_ref) {
        var value = _ref.value;
        return [!!value ? _c('v-icon', [_vm._v(" mdi-check ")]) : _vm._e()];
      }
    }, {
      key: `item.appliedAt`,
      fn: function (_ref2) {
        var _value$toDate;
        var value = _ref2.value;
        return [_c('span', {
          staticClass: "page-text--sm"
        }, [_vm._v(" " + _vm._s(value === null || value === void 0 ? void 0 : (_value$toDate = value.toDate) === null || _value$toDate === void 0 ? void 0 : _value$toDate.call(value)) + " ")])];
      }
    }, {
      key: `item.recruitment`,
      fn: function (_ref3) {
        var value = _ref3.value;
        return [_c('div', {
          staticClass: "page-text text-truncate"
        }, [_vm._v(_vm._s(value === null || value === void 0 ? void 0 : value.subject))]), _c('div', {
          staticClass: "page-text--sm grey-b3--text text-truncate"
        }, [_vm._v(_vm._s(value === null || value === void 0 ? void 0 : value.summary))])];
      }
    }, {
      key: `item.resume`,
      fn: function (_ref4) {
        var _value$personalInform, _value$personalInform2, _value$personalInform3, _value$personalInform4, _value$personalInform5;
        var value = _ref4.value;
        return [_c('div', {
          staticClass: "page-text text-truncate"
        }, [_vm._v(_vm._s(value === null || value === void 0 ? void 0 : value.name))]), _c('div', {
          staticClass: "page-text--sm grey-b3--text text-truncate"
        }, [_vm._v(" " + _vm._s([value === null || value === void 0 ? void 0 : (_value$personalInform = value.personalInformation) === null || _value$personalInform === void 0 ? void 0 : _value$personalInform.name, value === null || value === void 0 ? void 0 : (_value$personalInform2 = value.personalInformation) === null || _value$personalInform2 === void 0 ? void 0 : (_value$personalInform3 = _value$personalInform2.phone) === null || _value$personalInform3 === void 0 ? void 0 : (_value$personalInform4 = _value$personalInform3.phoneNumberFormat) === null || _value$personalInform4 === void 0 ? void 0 : _value$personalInform4.call(_value$personalInform3), value === null || value === void 0 ? void 0 : (_value$personalInform5 = value.personalInformation) === null || _value$personalInform5 === void 0 ? void 0 : _value$personalInform5.email].join(" / ")) + " ")])];
      }
    }, {
      key: "footer",
      fn: function () {
        return [_c('v-divider'), _c('v-pagination', {
          staticClass: "tab-others__pagination",
          attrs: {
            "length": _vm.pageCount,
            "total-visible": 11,
            "color": "primary"
          },
          model: {
            value: _vm.page,
            callback: function ($$v) {
              _vm.page = $$v;
            },
            expression: "page"
          }
        })];
      },
      proxy: true
    }], null, true)
  }, 'v-data-table', {
    headers: _vm.headers,
    items: _vm.items
  }, false)), _c(_vm.ViewComponent, {
    ref: "view",
    tag: "component",
    attrs: {
      "value": _vm.selected,
      "hide-others": ""
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }